import React, { useEffect, useState } from 'react';
import { getTerms } from '../../api/util';
import { PageTitle } from '../../components/title/PageTitle';
import DOMPurify from 'dompurify';

export default function Terms() {
  const [item, setItem] = useState<any>();
  useEffect(() => {
    getTerms('USE').then((res) => {
      setItem(res.data.use.contents);
    });
  }, []);
  return (
    <div className="main_wrap">
      <div className="contents_wrap">
        <PageTitle>이용약관</PageTitle>
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item) }}></div>
      </div>
    </div>
  );
}
